import React, { useRef, useEffect } from 'react';
import { Form } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
// import {
//   loginModalOpen,
//   loginIsLogin,
// } from '../../../actions/Login/login.action';
import withTranslations from 'app/components/HOGs/withTranslations';
import FreeProPopUp from './FreeProPopUp';
import { userActions } from '../../../actions/Users/user.sign.action';

import state from './getState.factory';
import SocialButtons from './socialButtons/socialButtons';
import {
  // START_LOGIN,
  LETTER_SENT,
} from '../../../constants/enter.user.constants';

const LoginStateMachine = (props) => {
  const { tr: loginText } = props;
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const userNameReference = useRef(null);

  const machine = useSelector((store) => store.userEnter);
  const dataLogin = useSelector((store) => store.loginData);
  const { currentLocation: loc } = useSelector((store) => store.userReducer);

  const { goToStateByName } = userActions;

  const goToState = (...arg) => {
    dispatch(goToStateByName(...arg));
  };

  const setStateMachine = () => {
    if (!state.getCurrent() || machine.name !== state.getCurrent().getName()) {
      state.create(machine.name, form, goToState);
    }
  };

  useEffect(() => {
    if (userNameReference.current) {
      userNameReference.current.focus();
    }
    return () => {
      state.destroy();
    };
  }, []);

  useEffect(() => {
    if (userNameReference.current && userNameReference.current.input) {
      userNameReference.current.focus();
      userNameReference.current.input = null;
    }
  }, [userNameReference.current]);

  setStateMachine();

  if (machine.name !== LETTER_SENT) {
    return (
      <>
        <Form className="login-form" form={form}>
          <FreeProPopUp
            isVisible={
              dataLogin.modalOpen && state.getCurrent().isShowFreePro()
            }
          >
            <div style={{ height: '43px', position: 'relative', top: '-17px' }}>
              <div className="loginTilte">{state.getCurrent().getTitle()}</div>
            </div>
          </FreeProPopUp>
          {state.getCurrent().render({
            ...machine,
            ref: userNameReference,
            loc,
            loginText,
          })}
        </Form>
        {state.getCurrent().isSocialButtonsAllowed() ? (
          <SocialButtons goTo={goToStateByName} />
        ) : (
          ''
        )}
      </>
    );
  }
  return state.getCurrent().render(machine);
};

export default withTranslations(LoginStateMachine);
